var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.figureClass,on:{"click":_vm.setZoomedImage}},[_vm._t("default"),_c('p',{staticClass:"caption",style:({color: _vm.myColors.onBackground, 'text-align': _vm.textAlignment, width: _vm.captionWidth})},[_vm._v(_vm._s(_vm.caption))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }